import React from 'react';
import BentoBox from './BentoBox';
import SkillBG from './SkillBG';
import {
  cssSvg,
  htmlSvg,
  javaSvg,
  jsSvg,
  pshellSvg,
  reactSvg,
  reduxSvg,
  tsSvg,
  d3Svg,
  gsapSvg,
  jestSvg,
  mongoSvg,
  nodeSvg,
  sassSvg,
  suiSvg,
  tailwindSvg,
  expressSvg,
  firebaseSvg,
  cypressSvg,
  rtlSvg,
} from '../Svgs';

const svgKeys = [
  'HTML',
  'CSS',
  'Javascript',
  'Typescript',
  'Java',
  'Powershell',
  'React',
  'Redux',
  'GSAP',
  'D3.js',
  'Express.js',
  'Node.js',
  'MongoDb',
  'Firebase',
  'Tailwind',
  'Semantic',
  'Sass',
  'Jest',
  'Cypress',
  'RTL',
];
 
const NewSkillBox = () => {
  return (
    <div id="skills-content">
      <div>
        <SkillBG />
      </div>
      <div className="bento-container">
        <BentoBox title="Web Foundations" keys={svgKeys.slice(0, 4)}>
          {htmlSvg}
          {cssSvg}
          {jsSvg}
          {tsSvg}
        </BentoBox>
        <BentoBox title="Miscellaneous" keys={svgKeys.slice(4, 6)}>
          {javaSvg}
          {pshellSvg}
        </BentoBox>
        <BentoBox title="Frontend" keys={svgKeys.slice(6, 10)}>
          {reactSvg}
          {reduxSvg}
          {gsapSvg}
          {d3Svg}
        </BentoBox>
        <BentoBox title="Backend" keys={svgKeys.slice(10, 14)}>
          {expressSvg}
          {nodeSvg}
          {mongoSvg}
          {firebaseSvg}
        </BentoBox>
        <BentoBox title="Styling" keys={svgKeys.slice(14, 17)}>
          {tailwindSvg}
          {suiSvg}
          {sassSvg}
        </BentoBox>
        <BentoBox title="Testing Frameworks" keys={svgKeys.slice(17, 20)}>
          {jestSvg}
          {cypressSvg}
          {rtlSvg}
        </BentoBox>
      </div>
    </div>
  );
};

export default NewSkillBox;
